<template>
	<section class="scrollbar rgtrStps">
	    <div class="container registerStes-form">
	        <div class="row align-items-center justify-content-center h-100">
	            <div class="col-12 col-lg-10">
	            	<loader v-if="pageLoader && !$parent.pageLoader"></loader>
	                <div class="customFotm stepsRegular position-relative bg-white border-radius-5 p-md-5 p-3">
	                	<span class="alert alert-danger" v-if="submitted && errors.has('membership')">Please select atleast one option</span>
                    	<h2 class="text-center mb-4">Client Membership</h2>
                        <div class="row mt-5" v-if="options.MENBERSHIPS_PLANS">
                            <div class="col-12 col-md-6" v-for="item in options.MENBERSHIPS_PLANS" v-if="item.parent_id == 0">
                            	<div class="visitTime position-relative" :class="[{'active':membership == item.id}]">
		                            <label class="customRadiobox"> {{item.name}}
		                                <input type="radio" :value="item.id" v-model="membership" name="membership" v-validate="'required'" @change="changeMembership()">
		                                <span class="checkmark"></span>
		                            </label>
		                        </div>
                            </div>
                            <div class="col-12 pt-5 pb-3" v-if="membership == 2">
	                            <div class="row mobDirection">
			                        <div class="col-12 col-lg-7">
			                        	<div class="leftDescription">
			                        		<div class="showInt" v-if="member_type == item.id" v-for="item in options.MENBERSHIPS_PLANS">
				                        		<h3>{{item.name}}</h3>
					                        	<ul class="listCheck" v-html="$env_var.membership_text[member_type]" v-if="member_type"></ul>
					                        </div>
					                        <div class="noPackegs text-center" v-if="member_type == ''">
					                        	<h5>Please Select Any Package </h5>
					                        	<img src="../../../../static/website/images/selectPack.svg" alt="Icon">
					                        </div>
				                        </div>
			                        </div>
			                        <div class="col-12 col-lg-5">
				                        <div class="basicPlan position-relative rtc" :class="[{'active':member_type == item.id}]" v-for="item in options.MENBERSHIPS_PLANS" v-if="membership && item.parent_id === membership">
				                        	 <label class="customRadiobox"> <span class="packages">{{item.name}}</span> 
				                        	 	<span class="priceHold"><span>Price</span> <b>{{item.price}}</b></span>
				                                <input type="radio" :value="item.id" v-model="member_type" name="member_type" v-validate="'required'">
				                                <span class="checkmark"></span>
				                            </label>
				                        </div>
			                        </div>
		                        </div>
                            	<span class="alert alert-danger position-relative w-100 d-block" v-if="submitted && errors.has('member_type')">Please Select Any Package</span>
                            </div>
                            <div class="col-12">
                                <div class="form-group text-center mt-4 mb-0">
                                    <button class="btn btn-link btn-blue"  @click.stop.prevent="submit()">Submit</button>
                                </div>
                            </div>
                        </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</section>
</template>
<script>
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	
	export default {
		name: 'client-membership',
		data() {
			return {
				pageLoader: false,
                notification_msg:'',
                notification_type:'',
				submitted: false,
				membership:'',
				member_type:'',
				// membershipList:{
				// 	'1':'Silver',
				// 	'2':'Gold',
				// 	'3':'Platinum'
				// }
			}
		},
		props:{
			options: {
		      default: {}
		    }
		},
		methods: {
			...mapActions({
				_runRegisterStep1: types.RUN_REGISTER_STEP1,
				_runGetRegisterStepData: types.RUN_GET_USER_REGISTERATION_STEP_DATA,
			}),
			changeMembership(){
				if(this.membership == 1){
					this.member_type = ''
				}
			},
			submit() {
				const _that = this
				this.submitted = true;
				this.$validator.validate().then(valid => {
					if (valid) {
						let input_json = {
							'globalParams': {
								membership_id : _that.membership
							},
							'localParams': {
								"parameter": _that
							}
						}
						if(_that.membership != 1){
							input_json.globalParams.membership_id = _that.member_type
						}
						_that._runRegisterStep1(input_json)
					}
				})
			}
		},
		created(){
			this._runGetRegisterStepData({'globalParams': {"step" : "1"},'localParams': {"parameter": this,'step':'1'}})
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/registerSteps/step1.vue